// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"b11f21ca","453":"f9d657c6","457":"d1a649a6","523":"94ff9d96","631":"b7d866b2"}[chunkId] + ".chunk.js";
};